import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MaterialIcon from 'material-icons-react';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Nav,
    NavItem,
    NavLink,
    Col,
    FormGroup,
    Label,
    Input
} from 'reactstrap';
import i18n from '../../../i18next';

import PromotionTypeScreen from './PromotionTypeScreen';
import PromotionConditionScreen from './PromotionConditionScreen';
import PromotionValidityScreen from './PromotionValidityScreen';
import PromotionPromoCodesScreen from './PromotionPromoCodesScreen';
import PromotionCategoryProductScreen from './PromotionCategoryProductScreen';
import PromotionImageScreen from './PromotionImageScreen';
import PromotionAdvancedScreen from './PromotionAdvancedScreen';
import { savePromotion, updatePromotion, dispatchErrorMessage, loadPromotionsSummary, uploadPromotionImage, loadPromotions } from '../../../actions/index';
import { PRICE_DISCOUNT, FREE_PRODUCT, COMBO_DEAL, AUTO_APPLY } from '../../../utils/Constants';


const initialState = {
    page: 1,
    tabClickedInEditMode: false,
    tabClicked: 1,
    requestTabChange: false,
    renderTabsWithoutCondition: false,
    name: null,
    promotion: {
        id: -1,
        coverageType: '',
        menuDtos: [],
        categoryDtos: [],
        productDtos: [],
        orderTypes: []
    },
    formSubmitted: false,
    invalidTabData: false,
    stateAlreadyCopiedFromProps: false
};

class PromotionScreen extends Component {
    constructor(props) {
        super(props);

        this.state = initialState;

        this.toggle = this.toggle.bind(this);
        this.activateChildFormValidation = this.activateChildFormValidation.bind(this);
        this.previousPage = this.previousPage.bind(this);
    }

    manageStateOnRender() {
        if (this.props.isOpen) {
            if (this.props.selectedPromotion !== undefined && this.props.selectedPromotion !== null &&
                (!this.state.stateAlreadyCopiedFromProps) || this.props.selectedPromotion.id !== this.state.promotion.id) {

                this.copyStateFromProps();
            }
        } else {
            this.resetModalState();
        }
    }

    copyStateFromProps() {
        if (this.props.copyMode && !this.state.stateAlreadyCopiedFromProps) {
            let promotionCopy = Object.assign({}, this.props.selectedPromotion);

            if (promotionCopy.id !== -1) {
                promotionCopy.name = promotionCopy.name + '- Copy';
            }

            promotionCopy.id = -1;

            promotionCopy.promoCodeUsageType = '';
            promotionCopy.promoCodeFromExternalSource = true;
            promotionCopy.promoCodeValues = '';

            if (promotionCopy.priceDiscount !== undefined && promotionCopy.priceDiscount !== null) {
                promotionCopy.priceDiscount.id = -1;
                delete promotionCopy.priceDiscount['id'];
            }

            if (promotionCopy.validity !== undefined && promotionCopy.validity !== null) {
                delete promotionCopy.validity['id'];
                delete promotionCopy.validity.customAvailableTime['id'];
            }

            this.setState({
                ...this.state,
                name: promotionCopy ? promotionCopy.name : '',
                promotion: promotionCopy,
                stateAlreadyCopiedFromProps: true
            });

        } else if (!this.props.copyMode && (this.props.editMode || this.props.selectedPromotion.id == -1)) {

            this.setState({
                ...this.state,
                name: this.props.selectedPromotion ? this.props.selectedPromotion.name : '',
                promotion: this.props.selectedPromotion ? this.props.selectedPromotion : initialState.promotion,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    resetModalState() {
        this.state = initialState;
        this.state.stateAlreadyCopiedFromProps = false;
    }
    /* Wizard Control Functions */
    nextPage() {
        // Copy Mode of Promotion
        if (this.props.copyMode) {
            const showConditionTabAndOnLastPageOfWizard = !this.state.renderTabsWithoutCondition && this.state.page === 7;
            const noConditionTabAndOnLastPageOfWizard = this.state.renderTabsWithoutCondition && this.state.page === 6;

            // If we render Condition and we are on the last tab submit the form
            if (showConditionTabAndOnLastPageOfWizard) {
                this.setState({...this.state, formSubmitted: true, page: 1, requestTabChange: false, invalidTabData: false});
                // this.toggle();

            } else if (noConditionTabAndOnLastPageOfWizard) { // If we DONT render Condition and on page 6 submit the form
                this.setState({...this.state, formSubmitted: true, page: 1, requestTabChange: false, invalidTabData: false});
                // this.toggle();

            } else { // Go to next page
                this.setState({...this.state, page: this.state.page + 1, requestTabChange: false, invalidTabData: false});
            }

            return;
        }

        // Go to next Page if wizard is in create mode
        if (this.state.promotion.id === -1) {
            const showConditionTabAndOnLastPageOfWizard = !this.state.renderTabsWithoutCondition && this.state.page === 7;
            const noConditionTabAndOnLastPageOfWizard = this.state.renderTabsWithoutCondition && this.state.page === 6;

            // If we render Condition and we are on the last tab submit the form
            if (showConditionTabAndOnLastPageOfWizard) {
                this.setState({...this.state, formSubmitted: true, page: 1, requestTabChange: false, invalidTabData: false});
            } else if (noConditionTabAndOnLastPageOfWizard) { // If we DONT render Condition and on page 6 submit the form
                this.setState({...this.state, formSubmitted: true, page: 1, requestTabChange: false, invalidTabData: false});
            } else { // Go to next page
                this.setState({...this.state, page: this.state.page + 1, requestTabChange: false, invalidTabData: false});
            }
        } else { // Submit form if the wizard is in edit mode
            this.setState({
                ...this.state,
                formSubmitted: (this.state.tabClickedInEditMode) ? false : true,
                requestTabChange: false,
                tabClickedInEditMode: false,
                tabClicked: this.state.page,
                invalidTabData: false,
                page: (this.state.page === this.state.tabClicked) ? this.state.page + 1 : this.state.tabClicked
            });
        }
    }

    previousPage() {
        this.setState({ page: this.state.page - 1 });
    }

    setActiveTab(tab) {
        if (this.props.copyMode) {
            this.setState({ requestTabChange: false, tabClicked: tab, page: tab});

            return;
        }

        if (this.state.page !== tab) this.setState({ tabClickedInEditMode: true, requestTabChange: true, tabClicked: tab });
    }

    toggle() {
        this.setState(initialState);
        this.props.onToggle();
    }
    /* Show/Hide condition tab Control */
    showConditionTab() {
        this.setState({ ...this.state, renderTabsWithoutCondition: false });
    }

    hideConditionTab() {
        this.setState({ ...this.state, renderTabsWithoutCondition: true });
    }
    /* Update Wizard State from the children tabs */
    updatePromotionStateFromType(updatedTabData) {
        //TODO why it changes the state from correct condition type to the wrong one
        let updatedPromotion = {};

        if (updatedTabData.discountType === PRICE_DISCOUNT) {
            updatedPromotion = {
                ...this.state.promotion,
                discountType: updatedTabData.discountType,
                priceDiscount: updatedTabData.priceDiscount,
                freeProduct: null,
                comboDeal: null,
                description: updatedTabData.description
            };
        } else if (updatedTabData.discountType === FREE_PRODUCT) {
            updatedPromotion = {
                ...this.state.promotion,
                discountType: updatedTabData.discountType,
                freeProduct: _.pick(updatedTabData.freeProduct, ['productId', 'quantity']),
                priceDiscount: null,
                comboDeal: null,
                description: updatedTabData.description
            };
        } else if (updatedTabData.discountType === COMBO_DEAL) {
            updatedPromotion = {
                ...this.state.promotion,
                discountType: updatedTabData.discountType,
                comboDeal: updatedTabData.comboDeal,
                freeProduct: null,
                priceDiscount: null,
                description: updatedTabData.description
            };
        }

        return updatedPromotion;
    }

    updatePromotion(tabData) {
        // Update state with data from Type tab
        if (tabData.discountType && this.props.isOpen) {
            let getPropsFromTabData = _.pick(tabData, ['discountType', 'priceDiscount', 'freeProduct', 'comboDeal', 'description']);

            let updatedPromotion = this.updatePromotionStateFromType(getPropsFromTabData);
            let description = getPropsFromTabData.description;

            if (this.state.promotion.id === -1) {
                this.setState({ ...this.state, promotion: updatedPromotion, description: description });
            }

            if (this.state.promotion.id !== -1) {
                //TODO why it changes the state from correct condition type to the wrong one
                if (updatedPromotion.discountType !== COMBO_DEAL && !updatedPromotion.discountValue && updatedPromotion.conditionValue == null) {
                    updatedPromotion.conditionType = AUTO_APPLY;
                }

                this.setState({ ...this.state, promotion: updatedPromotion }, () => {
                    if (this.state.formSubmitted) this.updateForm();
                });
            }
        }

        // Update state with data from Condition tab
        if (tabData.conditionType) {
            let getPropsFromTabData = _.pick(tabData, ['conditionType', 'conditionValue']);

            let updatedPromotion = {
                ...this.state.promotion,
                conditionType: getPropsFromTabData.conditionType,
                conditionValue: getPropsFromTabData.conditionValue,
            };

            if (this.state.promotion.id === -1) {
                this.setState({ ...this.state, promotion: updatedPromotion });
            }

            if (this.state.promotion.id !== -1) {
                this.setState({ ...this.state, promotion: updatedPromotion }, () => {
                    if (this.state.formSubmitted) this.updateForm();
                });
            }
        }

        // Update state with data from Validity
        if (tabData.endDate) {
            let getPropsFromTabData = _.pick(tabData, ['startDate', 'endDate', 'validOnMonday', 'validOnTuesday', 'validOnWednesday',
                'validOnThursday', 'validOnFriday', 'validOnSaturday', 'validOnSunday', 'customTime', 'customAvailableTime']);

            let updatedPromotion = {
                ...this.state.promotion,
                validity: {
                    startDate: getPropsFromTabData.startDate,
                    endDate: getPropsFromTabData.endDate,
                    validOnMonday: getPropsFromTabData.validOnMonday,
                    validOnTuesday: getPropsFromTabData.validOnTuesday,
                    validOnWednesday: getPropsFromTabData.validOnWednesday,
                    validOnThursday: getPropsFromTabData.validOnThursday,
                    validOnFriday: getPropsFromTabData.validOnFriday,
                    validOnSaturday: getPropsFromTabData.validOnSaturday,
                    validOnSunday: getPropsFromTabData.validOnSunday,
                    customTime: getPropsFromTabData.customTime,
                    customAvailableTime: getPropsFromTabData.customAvailableTime
                }
            };

            if (this.state.promotion.id === -1) {
                this.setState({ ...this.state, promotion: updatedPromotion });
            }

            if (this.state.promotion.id !== -1) {
                this.setState({ ...this.state, promotion: updatedPromotion }, () => {
                    if (this.state.formSubmitted) this.updateForm();
                });
            }
        }

        // Update state for CategoryProduct
        if (tabData.coverageType) {
            let getPropsFromTabData = _.pick(tabData, ['coverageType', 'menuDtos', 'categoryDtos', 'productDtos']);
            let updatedPromotion = {
                ...this.state.promotion,
                coverageType: getPropsFromTabData.coverageType,
                menuDtos: getPropsFromTabData.menuDtos,
                categoryDtos: getPropsFromTabData.categoryDtos,
                productDtos: getPropsFromTabData.productDtos
            };

            if (this.state.promotion.id === -1) {
                this.setState({ ...this.state, promotion: updatedPromotion });
            }

            if (this.state.promotion.id !== -1) {
                this.setState({ ...this.state, promotion: updatedPromotion }, () => {
                    if (this.state.formSubmitted) this.updateForm();
                });
            }
        }
        // Update state with data from PromoCodes
        if (tabData.promoCodeScreenOpened) {
            let updatedPromotion = {
                ...this.state.promotion,
                promoCodeUsageType: tabData.promoCodeUsageType,
                promoCodeFromExternalSource: tabData.promoCodeFromExternalSource,
                promoCodeValues: tabData.promoCodeValues,
                oneTimeDiscount: tabData.oneTimeDiscount,
                oneTimePerCustomer: tabData.oneTimePerCustomer
            };

            if (this.state.promotion.id === -1) {
                this.setState({ ...this.state, promotion: updatedPromotion });
            }

            if (this.state.promotion.id !== -1) {
                this.setState({ ...this.state, promotion: updatedPromotion }, () => {
                    if (this.state.formSubmitted) this.updateForm();
                });
            }
        }
        // Upload image for promotion
        // It is left only the check for undefined because when you are in edit mode
        // and you press save on 6. Promotion Image tab, the imageFormData and imagePath are
        // coming as null properties and it doesn't pass the if condition, the form is not
        // submitting, and the wizard is showing different tab ( it is not closing as it's expected).
        if (tabData.imageFormData !== undefined || tabData.imagePath !== undefined) {
            let getPropsFromTabData = _.pick(tabData, ['imagePath', 'imageFormData', 'imagePreview']);
            let updatedPromotion = {
                ...this.state.promotion,
                imagePath: getPropsFromTabData.imagePath,
                formData: getPropsFromTabData.imageFormData,
                imagePreview: getPropsFromTabData.imagePreview
            }
            const formData = getPropsFromTabData.imageFormData;

            if (this.state.promotion.id === -1) {
                this.setState({
                    ...this.state,
                    promotion: updatedPromotion,
                    formData: formData
                });
            }

            if (this.state.promotion.id !== -1) {
                this.setState({
                    ...this.state,
                    promotion: updatedPromotion
                }, () => {
                    if (this.state.formSubmitted) this.updateForm();
                });
            }
        }
        // Update state with data from Advanced
        if (tabData.orderTypes) {
            let getPropsFromTabData = _.pick(tabData, ['freeDelivery', 'discountNonDiscountableProducts', 'allowMultipleDiscounts', 'orderTypes']);
            let clearedDuplicatedOrderTypes = _.uniqBy(getPropsFromTabData.orderTypes, 'id');
            let updatedPromotion = {
                ...this.state.promotion,
                freeDelivery: getPropsFromTabData.freeDelivery,
                discountNonDiscountableProducts: getPropsFromTabData.discountNonDiscountableProducts,
                allowMultipleDiscounts: getPropsFromTabData.allowMultipleDiscounts,
                orderTypes: clearedDuplicatedOrderTypes
            };

            if (this.state.promotion.id === -1) {
                this.setState({ ...this.state, promotion: updatedPromotion }, () => {
                    if (this.state.formSubmitted) this.submitForm();
                });
            }

            if (this.state.promotion.id !== -1) {
                this.setState({ ...this.state, promotion: updatedPromotion }, () => {
                    if (this.state.formSubmitted) this.updateForm();
                });
            }
        }
    }
    /* Handle Wizard submission and update */
    submitFormCalled() {
        this.activateChildFormValidation();
    }

    submitForm() {
        let promotionData = {
            ...this.state.promotion,
            name: this.state.name,
        };
        // save promotion and reset submitted flag
        let restaurantId = this.props.restaurantId;
        let discountType = '';
        let promoCode = this.props.promoCode;
        let currentPageNumber = this.props.currentPageNumber
        
        this.props.savePromotion(restaurantId, promotionData, () => {
            // this.props.loadPromotionsSummary(restaurantId, discountType, currentPageNumber, promoCode);
            this.props.loadPromotions(restaurantId, discountType, currentPageNumber, promoCode);
            this.toggle();
        });

        
    }

    updateForm() {
        let promotionData = {
            ...this.state.promotion,
            name: this.state.name
        };
        // update promotion and reset submitted flag
        let promotionId = this.state.promotion.id;
        let restaurantId = this.props.restaurantId;
        let discountType = '';
        let promoCode = this.props.promoCode;
        let currentPageNumber = this.props.currentPageNumber

        this.props.updatePromotion(promotionId, restaurantId, promotionData, () => {
            // this.props.loadPromotionsSummary(restaurantId, discountType, currentPageNumber, promoCode);
            this.props.loadPromotions(restaurantId, discountType, currentPageNumber, promoCode);
        }, promotionData.formData);

        this.toggle();
    }

    activateChildFormValidation() {
        if (!this.state.name) {
            this.props.dispatchErrorMessage(i18n.t('screens:promotionScreen.missingName'));

            return;
        }

        this.setState({ ...this.state, requestTabChange: true });
    }
    /* Render Functions */
    renderPromotionName() {

        return (
            <FormGroup row>
                <Label for="promotionName" sm={1} style={styles.promotionNameLabel}>{i18n.t('common:form.name')}</Label>
                <Col sm={11}>
                    <Input type="text" name="name" id="promotionName"
                        value={this.state.name ? this.state.name : ''}
                        onChange={this.handleChange.bind(this)}
                        placeholder={i18n.t('screens:promotionScreen.promotionNamePlaceholder')}
                    />
                </Col>
            </FormGroup>
        );
    }

    handleChange({ target }) {
        this.setState({ ...this.state, [target.name]: target.value });
    }

    renderTabsWithoutCondition() {
        const { page } = this.state;
        let tabStyle = null;
        (this.props.editMode || this.props.copyMode) ? tabStyle = 'allow-click-on-tab' : tabStyle = '';

        let isTabDisabled = true;

        if (this.props.editMode || this.props.copyMode) {
            isTabDisabled = false;
        }

        const tabsArray = ['type', 'validity', 'promoCodes', 'categoryProduct', 'image', 'advanced'];

        return (
            <div>
                <Nav tabs>
                    {
                        tabsArray.map((tab, i) => {
                            let iterator = (i += 1);
                            return (
                                <NavItem className={tabStyle}>
                                    <NavLink
                                        className={this.state.page === iterator ? 'active' : ''}
                                        // if in create mode add disabled
                                        disabled={isTabDisabled}
                                        onClick={() => {
                                            this.setActiveTab(iterator);
                                        }}>

                                        {`${iterator}. ${i18n.t(`screens:promotionScreen.${tab}Tab`)}`}

                                    </NavLink>
                                </NavItem>
                            );
                        })
                    }
                </Nav>

                {page === 1 && <PromotionTypeScreen
                    restaurant={this.props.restaurant}
                    restaurantId={this.props.restaurantId}
                    promotionId={this.state.promotion ? this.state.promotion.id : null}
                    discountType={this.state.promotion ? this.state.promotion.discountType : PRICE_DISCOUNT}
                    priceDiscount={this.state.promotion ? this.state.promotion.priceDiscount : null}
                    freeProduct={this.state.promotion ? this.state.promotion.freeProduct : null}
                    comboDeal={this.state.promotion ? this.state.promotion.comboDeal : null}
                    description={this.state.promotion ? this.state.promotion.description: this.props.selectedPromotion.description}

                    showConditionTab={this.showConditionTab.bind(this)}
                    hideConditionTab={this.hideConditionTab.bind(this)}

                    requestTabChange={this.state.requestTabChange}
                    cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                    setInvalidTabData={this.setInvalidTabData.bind(this)}
                    goToNextPage={this.nextPage.bind(this)}
                    getPageData={this.updatePromotion.bind(this)}
                />}

                {page === 2 && <PromotionValidityScreen
                    restaurantId={this.props.restaurantId}
                    promotionId={this.state.promotion ? this.state.promotion.id : null}
                    validity={this.state.promotion ? this.state.promotion.validity : null}

                    requestTabChange={this.state.requestTabChange}
                    cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                    setInvalidTabData={this.setInvalidTabData.bind(this)}
                    goToNextPage={this.nextPage.bind(this)}
                    getPageData={this.updatePromotion.bind(this)}
                />}

                {page === 3 && <PromotionPromoCodesScreen
                    validityData={this.state.validityData}
                    promotionId={this.state.promotion ? this.state.promotion.id : null}
                    restaurantId={this.props.restaurantId}
                    selectedPromotion={(this.props.editMode && !this.props.copyMode) ? this.props.selectedPromotion : this.state.promotion}
                    oneTimeDiscount={this.state.promotion ? this.state.promotion.oneTimeDiscount : null}
                    oneTimePerCustomer={this.state.promotion ? this.state.promotion.oneTimePerCustomer : null}

                    requestTabChange={this.state.requestTabChange}
                    cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                    setInvalidTabData={this.setInvalidTabData.bind(this)}
                    goToNextPage={this.nextPage.bind(this)}
                    getPageData={this.updatePromotion.bind(this)}
                />}

                {page === 4 && <PromotionCategoryProductScreen
                    restaurantId={this.props.restaurantId}
                    selectedPromotion={this.state.promotion}

                    requestTabChange={this.state.requestTabChange}
                    cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                    setInvalidTabData={this.setInvalidTabData.bind(this)}
                    goToNextPage={this.nextPage.bind(this)}
                    getPageData={this.updatePromotion.bind(this)}

                    styles={styles}
                />}

                {page === 5 && <PromotionImageScreen
                    restaurantId={this.props.restaurantId}
                    selectedPromotion={this.state.promotion}

                    requestTabChange={this.state.requestTabChange}
                    cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                    setInvalidTabData={this.setInvalidTabData.bind(this)}
                    goToNextPage={this.nextPage.bind(this)}
                    getPageData={this.updatePromotion.bind(this)}
                    dispatchErrorMessage={this.props.dispatchErrorMessage}
                    styles={styles}
                />}

                {page === 6 && <PromotionAdvancedScreen
                    restaurantId={this.props.restaurantId}
                    orderTypes={this.state.promotion ? this.state.promotion.orderTypes : null}
                    freeDelivery={this.state.promotion ? this.state.promotion.freeDelivery : null}
                    discountNonDiscountableProducts={this.state.promotion ? this.state.promotion.discountNonDiscountableProducts : null}
                    allowMultipleDiscounts={this.state.promotion ? this.state.promotion.allowMultipleDiscounts : null}

                    requestTabChange={this.state.requestTabChange}
                    cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                    setInvalidTabData={this.setInvalidTabData.bind(this)}
                    goToNextPage={this.nextPage.bind(this)}
                    getPageData={this.updatePromotion.bind(this)}
                    formSubmitted={this.state.formSubmitted}

                    styles={styles}
                />}

            </div>
        );
    }

    cancelTabChange() {
        this.setState({ ...this.state, requestTabChange: false });
    }

    setInvalidTabData() {
        this.setState({
            ...this.state,
            invalidTabData: true,
            requestTabChange: false,
            tabClickedInEditMode: false,
            tabClicked: this.state.page
        });
    }

    renderTabs() {
        const { page } = this.state;
        let tabStyle = null;
        (this.props.editMode || this.props.copyMode) ? tabStyle = 'allow-click-on-tab' : tabStyle = '';

        let isTabDisabled = true;

        if (this.props.editMode || this.props.copyMode) {
            isTabDisabled = false;
        }

        const tabsArray = ['type', 'condition', 'validity', 'promoCodes', 'categoryProduct', 'image', 'advanced'];

        if (this.state.stateAlreadyCopiedFromProps) {

            return (
                <div>
                    <Nav tabs>
                        {
                            tabsArray.map((tab, i) => {
                                let iterator = i += 1;

                                return (
                                    <NavItem className={tabStyle}>
                                        <NavLink
                                            className={this.state.page === iterator ? 'active' : ''}
                                            // if in create mode add disabled
                                            disabled={isTabDisabled}
                                            onClick={() => {
                                                this.setActiveTab(iterator);
                                            }}>

                                            {`${iterator}. ${i18n.t(`screens:promotionScreen.${tab}Tab`)}`}
                                        </NavLink>
                                    </NavItem>
                                );
                            })
                        }
                    </Nav>

                    {page === 1 && <PromotionTypeScreen
                        restaurant={this.props.restaurant}
                        restaurantId={this.props.restaurantId}
                        promotionId={this.state.promotion ? this.state.promotion.id : null}
                        discountType={this.state.promotion ? this.state.promotion.discountType : PRICE_DISCOUNT}

                        priceDiscount={this.state.promotion ? this.state.promotion.priceDiscount : null}
                        freeProduct={this.state.promotion ? this.state.promotion.freeProduct : null}
                        comboDeal={this.state.promotion ? this.state.promotion.comboDeal : null}
                        description={this.state.promotion ? this.state.promotion.description: this.props.selectedPromotion.description}

                        showConditionTab={this.showConditionTab.bind(this)}
                        hideConditionTab={this.hideConditionTab.bind(this)}

                        requestTabChange={this.state.requestTabChange}
                        cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                        setInvalidTabData={this.setInvalidTabData.bind(this)}
                        goToNextPage={this.nextPage.bind(this)}
                        getPageData={this.updatePromotion.bind(this)}
                    />}

                    {page === 2 && <PromotionConditionScreen
                        restaurantId={this.props.restaurantId}
                        promotionId={this.state.promotion ? this.state.promotion.id : null}
                        conditionType={this.state.promotion ? this.state.promotion.conditionType : null}
                        conditionValue={this.state.promotion ? this.state.promotion.conditionValue : null}

                        requestTabChange={this.state.requestTabChange}
                        cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                        setInvalidTabData={this.setInvalidTabData.bind(this)}
                        goToNextPage={this.nextPage.bind(this)}
                        getPageData={this.updatePromotion.bind(this)}
                    />}

                    {page === 3 && <PromotionValidityScreen
                        restaurantId={this.props.restaurantId}
                        promotionId={this.state.promotion ? this.state.promotion.id : null}
                        validity={this.state.promotion ? this.state.promotion.validity : null}

                        requestTabChange={this.state.requestTabChange}
                        cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                        setInvalidTabData={this.setInvalidTabData.bind(this)}
                        goToNextPage={this.nextPage.bind(this)}
                        getPageData={this.updatePromotion.bind(this)}
                    />}

                    {page === 4 && <PromotionPromoCodesScreen
                        validityData={this.state.validityData}
                        promotionId={this.state.promotion ? this.state.promotion.id : null}
                        restaurantId={this.props.restaurantId}
                        selectedPromotion={(this.props.editMode && !this.props.copyMode) ? this.props.selectedPromotion : this.state.promotion}
                        oneTimeDiscount={this.state.promotion ? this.state.promotion.oneTimeDiscount : null}
                        oneTimePerCustomer={this.state.promotion ? this.state.promotion.oneTimePerCustomer : null}
                        
                        requestTabChange={this.state.requestTabChange}
                        cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                        setInvalidTabData={this.setInvalidTabData.bind(this)}
                        goToNextPage={this.nextPage.bind(this)}
                        getPageData={this.updatePromotion.bind(this)}
                    />}

                    {page === 5 && <PromotionCategoryProductScreen
                        restaurantId={this.props.restaurantId}
                        selectedPromotion={this.state.promotion}

                        requestTabChange={this.state.requestTabChange}
                        cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                        setInvalidTabData={this.setInvalidTabData.bind(this)}
                        goToNextPage={this.nextPage.bind(this)}
                        getPageData={this.updatePromotion.bind(this)}

                        styles={styles}
                    />}

                    {page === 6 && <PromotionImageScreen
                        restaurantId={this.props.restaurantId}
                        selectedPromotion={this.state.promotion}

                        requestTabChange={this.state.requestTabChange}
                        cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                        setInvalidTabData={this.setInvalidTabData.bind(this)}
                        goToNextPage={this.nextPage.bind(this)}
                        getPageData={this.updatePromotion.bind(this)}
                        dispatchErrorMessage={this.props.dispatchErrorMessage}
                        styles={styles}
                    />}

                    {page === 7 && <PromotionAdvancedScreen
                        restaurantId={this.props.restaurantId}
                        orderTypes={this.state.promotion ? this.state.promotion.orderTypes : null}
                        freeDelivery={this.state.promotion ? this.state.promotion.freeDelivery : null}
                        discountNonDiscountableProducts={this.state.promotion ? this.state.promotion.discountNonDiscountableProducts : null}
                        allowMultipleDiscounts={this.state.promotion ? this.state.promotion.allowMultipleDiscounts : null}

                        requestTabChange={this.state.requestTabChange}
                        cancelTabChangeRequest={this.cancelTabChange.bind(this)}
                        setInvalidTabData={this.setInvalidTabData.bind(this)}
                        goToNextPage={this.nextPage.bind(this)}
                        getPageData={this.updatePromotion.bind(this)}
                        formSubmitted={this.state.formSubmitted}

                        styles={styles}
                    />}

                </div>
            );
        }
    }

    render() {
        if (!this.props) {
            return;
        }

        const { page } = this.state;

        this.manageStateOnRender();

        let modalSize;
        if (this.state.renderTabsWithoutCondition) {
            modalSize = 'promotions-modal';
        } else {
            modalSize = 'promotions-modal-large';
        }

        return (
            <div>
                <Modal className={modalSize} isOpen={this.props.isOpen} toggle={this.toggle}>
                    <ModalHeader className="modalHeader" toggle={this.toggle}>{i18n.t('screens:promotionScreen.promotionName')}</ModalHeader>
                    <ModalBody className='promotions-maker-body'>
                        {this.renderPromotionName()}
                        {!this.state.renderTabsWithoutCondition ? this.renderTabs() : this.renderTabsWithoutCondition()}
                    </ModalBody>
                    <ModalFooter>
                        {(page >= 2 && !this.props.editMode) ?
                            <Button outline color="primary" onClick={this.previousPage}>
                                <MaterialIcon icon="arrow_back_ios" color="#1C8DD3" size={20} />
                                <span style={{paddingLeft: '4px'}}>{i18n.t('common:buttons.back')}</span>
                            </Button>
                            : null}
                        {((page < 7 && !this.props.editMode && !this.state.renderTabsWithoutCondition) || (page < 6 && !this.props.editMode && this.state.renderTabsWithoutCondition)) ?
                            <Button outline color="primary" onClick={this.activateChildFormValidation}>
                                 <span style={{paddingLeft: '4px'}}>{i18n.t('common:buttons.next')}</span>
                                <MaterialIcon icon="arrow_forward_ios" color="#1C8DD3" size={20} />
                            </Button>
                            : null}
                        {((page === 7 && !this.state.renderTabsWithoutCondition) || (page === 6 && this.state.renderTabsWithoutCondition) || (this.props.editMode)) ?
                            <Button color="primary" onClick={this.activateChildFormValidation}>
                                <MaterialIcon icon="save" color="#fff" size={18} />
                                <span style={{paddingLeft: '4px'}}>{i18n.t('common:buttons.save')}</span>
                            </Button>
                            : null}
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default connect(null, {
    savePromotion,
    updatePromotion,
    dispatchErrorMessage,
    loadPromotionsSummary,
    uploadPromotionImage,
    loadPromotions
})(PromotionScreen);

const styles = {
    promotionNameLabel: {
        position: 'relative',
        top: 5
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionScreen.js